import React from 'react';
import { Hero } from './components/Hero';
import { Empathy } from './components/Empathy';
import { Problem } from './components/Problem';
import { Features } from './components/Features';
import { Authority } from './components/Authority';
import { Footer } from './components/Footer';
import { CTAButton } from './components/CTAButton';
export function App() {
  return <div className="min-h-screen bg-dark-900 selection:bg-brand-muted selection:text-dark-900" data-id="element-0">
      <Hero data-id="element-1" />
      <Empathy data-id="element-2" />
      <CTAButton label="Sí, quiero entender lo que siento" data-id="element-3" />
      <Problem data-id="element-4" />
      <CTAButton label="Aprender a cambiar las reglas del juego" data-id="element-5" />
      <Features data-id="element-6" />
      <CTAButton label="Descargar la guía completa ahora" data-id="element-7" />
      <Authority data-id="element-8" />
      <CTAButton label="Quiero mi eBook y empezar hoy" data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}